import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import { api } from "../../utils/apiClient";
import LoadingShimmer from "../../utils/LoadingShimmer";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";
import { showDeleteConfirm } from "../../utils/deleteConfirm";
import PrayerRequestTable from "../../components/tables/PrayerRequestTable";

let searchTimeout;

const PrayerRequest = () => {
    const [prayerRequests, setPrayerRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);

    const [sort, setSort] = useState("created_at");
    const [order, setOrder] = useState("desc");

    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const [entriesPerPage, setEntriesPerPage] = useState(10);

    const fetchPrayerRequests = async () => {
        try {
            setLoading(true);

            const response = await api.get("/prayer-request", {
                params: {
                    page,
                    limit: entriesPerPage,
                    sort,
                    order,
                    search: debouncedSearch?.trim() || "",
                },
            });

            setPrayerRequests(response.data.data || []);

            setTotalPages(
                response?.data?.pagination?.totalPages || 1
            );

            setTotalEntries(
                response?.data?.pagination?.total || 0
            );

        } catch (error) {
            console.error("Error fetching prayer requests:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        clearTimeout(searchTimeout);

        searchTimeout = setTimeout(() => {
            setDebouncedSearch(search);
            setPage(1);
        }, 1000);

        return () => clearTimeout(searchTimeout);
    }, [search]);

    useEffect(() => {
        fetchPrayerRequests();
    }, [page, entriesPerPage, sort, order, debouncedSearch]);

    const handleRefresh = () => {
        fetchPrayerRequests();
    };

    const handleDelete = async (id) => {
        try {
            await api.delete(`/prayer-request/${id}`);

            setPrayerRequests((prev) =>
                prev.filter((item) => item.id !== id)
            );

            toast.success("Prayer request deleted successfully");
        } catch (error) {
            console.error(error);
            toast.error("Failed to delete prayer request");
        }
    };

    const handleDeleteClick = (id) => {
        showDeleteConfirm(() => handleDelete(id));
    };

    return (
        <>
            <div className="page-header-row">
                <Breadcrumb title="Prayer Request" />

                <div className="filter-wrapper">
                    <Icon
                        icon="mdi:refresh"
                        width="26"
                        height="26"
                        className={`ms-2 d-inline-flex d-md-none mobile-refresh-icon ${loading ? "spin" : ""
                            }`}
                        onClick={handleRefresh}
                    />
                </div>
            </div>

            {loading ? (
                <LoadingShimmer
                    columns={3}
                    rows={6}
                    actionColumnIndex={2}
                />
            ) : (
                <PrayerRequestTable
                    prayerRequests={prayerRequests}
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    sort={sort}
                    order={order}
                    setSort={setSort}
                    setOrder={setOrder}
                    search={search}
                    setSearch={setSearch}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                    fetchPrayerRequests={fetchPrayerRequests}
                    onDelete={handleDeleteClick}
                />
            )}
        </>
    );
};

export default PrayerRequest;